import { render, staticRenderFns } from "./expenseStatisticsDetail.vue?vue&type=template&id=031c1b45&scoped=true"
import script from "./expenseStatisticsDetail.vue?vue&type=script&lang=js"
export * from "./expenseStatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./expenseStatisticsDetail.vue?vue&type=style&index=0&id=031c1b45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c1b45",
  null
  
)

export default component.exports